import { Chip } from '@mui/material';
import {
  SUPPLY_ORDER_STATUS_COLORS,
} from '../constants/supplyOrdersConstants';
import { formatSupplyOrderStatus } from '../utils/supplyOrdersUtils';

const SupplyOrderStatusChip = ({
  status,
  label,
  size = 'small',
  variant = 'outlined',
  ...chipProps
}) => {
  if (!status) return null;

  const displayLabel = label || formatSupplyOrderStatus(status);
  const color = SUPPLY_ORDER_STATUS_COLORS[status] || 'default';

  return (
    <Chip
      label={displayLabel}
      color={color}
      size={size}
      variant={variant}
      {...chipProps}
    />
  );
};

export default SupplyOrderStatusChip;
